module.exports = __webpack_public_path__ + "static/media/halfSelect.60b7fe5f.svg";